type GInfoCardProps = {
  title?: React.ReactNode
  subtitle?: React.ReactNode
  rightContent?: React.ReactNode
  headerIcon?: React.ReactNode
  children?: React.ReactNode
  footer?: React.ReactNode
  // styles
  bg?: string
  border?: string
  padding?: string
  rounded?: string
  className?: string
  // text control
  noWrap?: boolean
}

export const GInfoCard = ({ title,subtitle, rightContent,headerIcon,children, footer, bg = "bg-[#F4F4F5]", border = "border border-[#D9D9D9]", padding = "p-3", rounded = "rounded-xl", className = "", noWrap = false, }: GInfoCardProps) => {
  return (
    <div className={` w-full max-w-full overflow-hidden ${bg} ${border} ${padding} ${rounded} ${className} pt-2 `}  >
      {/* HEADER */}
      {(title || rightContent) && (
        <div className="flex justify-between items-center gap-2 w-full overflow-hidden p-1 pl-0">
            <p className={` uppercase truncate  ${noWrap ? "whitespace-nowrap overflow-hidden text-ellipsis" : ""} `} >
              {title}
            </p>
          {rightContent && (<div className="flex-shrink-0">{rightContent}</div>)}
        </div>
      )}

      {/* SUBTITLE --  ${noWrap ? "text-nowrap overflow-hidden text-ellipsis" : ""}*/}
      {subtitle && (  <p className={`max-w-full text-10-roboto`} >  {subtitle}   </p>   )}

      {/* BODY */}
      {children && (<div className="w-full mt-2 overflow-hidden"> <div className="w-full max-w-full overflow-hidden">
            {children}
        </div>  </div>  )}
    </div>
  )
}